// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";

// import echarts from "echarts";
// Vue.prototype.$echarts = echarts;

import { DecryptObj, Encrypt } from "@/assets/js/encryp.js";

Vue.prototype.$Encrypt = Encrypt;
Vue.prototype.$Decrypt = DecryptObj;


//引入rem适配
// import "@/assets/js/flexible.js";
Vue.config.productionTip = false;


import VueAwesomeSwiper from "vue-awesome-swiper";

// import style  import 'node_modules/vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import "swiper/dist/css/swiper.css";

Vue.use(VueAwesomeSwiper);

// router.beforeEach((to, from, next) => {
  
//   if (isMobile()) {
//     console.log(to.name);
//     if (to.name.indexOf("_p") != -1) {
//       next({ name: to.name.replace(/_p/, "_m"), query: to.query });
//     }
//   } else if (!isMobile()) {
//     if (to.name.indexOf("_m") != -1) {
//         console.log(to.name.replace(/_m/, "_p"));
//       next({ name: to.name.replace(/_m/, "_p"), query: to.query });
//     }
//   }
//   next();
// });


import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import "@/assets/directives/flex_for";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js